import React from 'react'
import PulseOxRangeItem from '../RangeItems/PulseOxRangeItem'
import { Box, Divider } from '@mui/material'

export default function BloodOxygenCard (props) {
  const sectionData = props.sectionData

  const renderDivider = (shouldShow) => {
    return (<>{shouldShow && !props.shouldRenderCondensed && <Divider className='care-plan-item__divider' />}</>)
  }

  return (
    <div className='care-plan__section' data-testid='care-plan__section__blood-oxygen'>
      <div className='care-plan__section-header'>SpO₂</div>
      {sectionData.rangeSubTypes.map((item, i, allElements) => {
        return (
          <Box key={`pulseoxrangeitem__${item}`}>
            <PulseOxRangeItem {...props} subtype={item} />
            {renderDivider(i < allElements.length - 1)}
          </Box>
        )
      })}
    </div>
  )
}
